/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteFacilityPhysician200ResponseData
 */
export interface DeleteFacilityPhysician200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof DeleteFacilityPhysician200ResponseData
     */
    id?: string;
}

/**
 * Check if a given object implements the DeleteFacilityPhysician200ResponseData interface.
 */
export function instanceOfDeleteFacilityPhysician200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteFacilityPhysician200ResponseDataFromJSON(json: any): DeleteFacilityPhysician200ResponseData {
    return DeleteFacilityPhysician200ResponseDataFromJSONTyped(json, false);
}

export function DeleteFacilityPhysician200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityPhysician200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function DeleteFacilityPhysician200ResponseDataToJSON(value?: DeleteFacilityPhysician200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

